import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import axios from 'axios'
import Constant from '../../Constant'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'
class TopEventCategoryList extends React.Component {
  state = {
    Products_data: [],
    isloading: false,
    isEditing: false,
    isEditingOrderNumber: false,
    editingOrderNumberId: null,
  }

  componentDidMount() {
    this.dashbord()
  }

  onOrderNumberEdit = (id, order) => {
    this.setState({
      editingOrderNumberId: id,
      editingOrderValue: order,
      isEditingOrderNumber: true,
    })
  }

  onOrderNumberSave = async () => {
    if (this.state.editingOrderNumberId && this.state.editingOrderValue) {
      axios
        .put(
          Constant.getAPI() + '/event-categories/edit-event-category',
          {
            order_no: this.state.editingOrderValue,
            id: this.state.editingOrderNumberId,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          }
        )
        .then((data) => {
          if (data.status === 200 && data.data) {
            let tempList = this.state.Products_data

            tempList.forEach((item) => {
              if (item.id === this.state.editingOrderNumberId) {
                item.order_no = this.state.editingOrderValue
              }
            })

            this.setState({
              Products_data: tempList,
              editingOrderNumberId: null,
              editingOrderValue: null,
              isEditingOrderNumber: false,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      this.setState({
        editingOrderNumberId: null,
        editingOrderValue: null,
        isEditingOrderNumber: false,
      })
    }
  }

  onOrderNumberChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value })
  }

  deleteCategory = (id) => {
    var token = `Bearer ${localStorage.getItem('loged_In_auth')}`

    axios
      .delete(Constant.getAPI() + `/event-categories/delete-top-event-category/${id}`, {
        headers: { Authorization: token, country_short_name: `${localStorage.getItem('countryShortName')}` },
      })
      .then(() => {
        Swal.fire({
          title: 'Item Deleted Successfully!',
          icon: 'success',
          text: '',
          type: 'success',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
        this.dashbord()
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  dashbord = async () => {
    var that = this
    await axios
      .get(Constant.getAPI() + `/event-categories/list-top-event-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            Products_data: res.data?.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  handleStatusChange = async (id, isActive) => {
    var that = this
    var data = {
      id: id,
      is_active: isActive,
    }
    await axios
      .put(Constant.getAPI() + '/event-categories/update-category-status', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          that.dashbord()
        }
      })
      .catch((err) => {
        that.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }
  render() {
    const columns = [
      {
        name: 'image',
        label: 'Image',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (category_img_url) => {
            return (
              <div>
                {category_img_url !== null ? (
                  <img
                    src={
                      category_img_url !== undefined && category_img_url !== null && category_img_url !== {}
                        ? Constant.getImage() + category_img_url
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                ) : (
                  <img
                    src={
                      category_img_url !== undefined && category_img_url !== null && category_img_url !== {}
                        ? Constant.getImage() + category_img_url
                        : './assets/images/icon.png'
                    }
                    className="img-fluid img-40"
                    alt="tbl"
                  />
                )}
              </div>
            )
          },
        },
      },
      {
        name: 'name_en',
        label: 'Name English',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'name_ar',
        label: 'Name Arabic',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'category_name_en',
        label: 'Category: English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'category_name_ar',
        label: 'Category: Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'company_name_en',
        label: 'Company: English',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'company_name_ar',
        label: 'Company: Arabic',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => {
            return value || '--'
          },
        },
      },
      {
        name: 'category_type',
        label: `Category Type`,
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'order',
        label: 'Order No.',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/top-event-category/add/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <span
                  onClick={this.deleteCategory.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Delete"
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>{' '}
                </span>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
      // {
      //     name: "id",
      //     label: "View Event Company",
      //     options: {
      //         filter: false,
      //         sort: true,
      //         customBodyRender: (id) => {

      //             return (
      //                 <div>
      //                     <Link
      //                         to={`/top-event-companies/` + id}
      //                         className="m-r-15 text-muted"
      //                         data-toggle="tooltip"
      //                         data-placement="top"
      //                         title=""
      //                         data-original-title="View Events "
      //                     >
      //                         <i className="f-22 icofont icofont-eye text-dark"></i>
      //                     </Link>
      //                 </div>
      //             );
      //         },
      //     },
      // },
    ]
    const options = {
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Top Event Category List</h4>
                    </div>
                  </div>
                  <Link
                    to={`/top-event-category/add`}
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    <i className="icofont icofont-plus m-r-5"></i> Add Event Category
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Top Event Category List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        {this.state?.isloading ? (
                          'loading...'
                        ) : (
                          <MUIDataTable
                            title={`Top Event Category List`}
                            className="table-responsive"
                            data={this.state.Products_data}
                            columns={columns}
                            options={options}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TopEventCategoryList
